fragment flexiblePostCards on flexibleSections_postCards_BlockType {
    __typename
}
